import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { ProductSchemaService } from './product-schema.service';
import { SchemaActions } from './product-schemas.actions';

@Injectable()
export class ProductSchemasEffects {
  constructor(
    private actions$: Actions,
    private schemaService: ProductSchemaService
  ) {}

  schema$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SchemaActions.getProductSchemaByQuery),
      switchMap(({ payload }) =>
        this.schemaService.getProductSchemaById(payload).pipe(
          map((res: any) =>
            SchemaActions.getProductSchemaByQuerySuccess({
              payload: { view: res, query: payload },
            })
          ),
          catchError(({ error }) =>
            of(SchemaActions.getProductSchemaByQueryFailure({ payload: error }))
          )
        )
      )
    )
  );

  schemasBySids$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SchemaActions.getSIDsSchema),
      switchMap(({ payload }) =>
        this.schemaService.getSchemasBySids(payload).pipe(
          map(({ res }: any) =>
            SchemaActions.getSIDSchemaSuccess({ payload: res })
          ),
          catchError(({ error }) =>
            of(SchemaActions.getSIDSchemaFailure({ payload: error }))
          )
        )
      )
    )
  );
}
